/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sim': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M201.6 250H55.4C41.9 250 31 239.1 31 225.6v-195C31 17.2 41.9 6.3 55.4 6.3h91.8c7.3 0 14.1 3.2 18.7 8.8l54.4 65.3c3.6 4.4 5.6 9.9 5.6 15.6v129.6c.1 18.9-5.4 24.4-24.3 24.4zM147.1 30.7H55.4v195h146.2V96l-54.5-65.3z"/><path pid="1" d="M67.6 55H92v36.6H67.6zM104.1 55h24.4v36.6h-24.4z"/>'
  }
})
